<template>
  <div>
     <iframe  style="width:100%;height:500px" :src="this.url"  title="SoftlineAngola"></iframe>
  </div>
  </template>

<script>
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import impressaoService from '../../services/impressaoService'
const ls = require('local-storage')
export default {
  data: () => ({
    idCliente: ls.get('itemsFaturaEstaticos').cliente[0].idCliente,
    saldoEstudante: 0,
    resumoImposto:ls.get('resumoImposto'),
    dataVendaFactura: ls.get('data_venda_factura'),
    dataVendaFacturaFull: ls.get('data_venda_factura_full'),
    lastInscricaoNaTurma: ls.get('lastMAtriculaOfStudent'),
    saldo:ls.get('saldo'),
    saldoUsado: ls.get('saldoUsando'),
    url: '',
    html: '',
    autor:ls.get('nomeUsuario'),
    total_recibo: '57 500,00 AOK',
    empresa: {
      director1: 'CUSTÓDIO ADOLFO CALEI',
      director2: 'SANDRA DAVID GONÇALVES'
    },
    itemsDaFactura: ls.get('itemsFatura'),
    infoFactura:ls.get('itemsFaturaEstaticos'),
    factura:
  {
    'factura_recibo': ls.get('itemsFaturaEstaticos').numeroDocumento,
    'bolseiro': (ls.get('bolseiro').length) ? (ls.get('bolseiro')[0].ongBolsa + '-' + ls.get('bolseiro')[0].percentagem) : 'Não',
    'cliente': ls.get('itemsFaturaEstaticos').cliente,
    'matricula': ls.get('itemsFaturaEstaticos').matricula,
    'curso': ls.get('itemsFaturaEstaticos').cliente[0].descricao,
    'classe': ls.get('itemsFaturaEstaticos').cliente[0].classe_descricao,
    'items': ls.get('itemsFatura'),
    'total_pagar': ls.get('itemsFaturaEstaticos').valorApagar,
    'total_pago': ls.get('itemsFaturaEstaticos').valorPago,
    'troco': ls.get('itemsFaturaEstaticos').troco,
    'valorIliquido':ls.get('valorIliquido'),
    'dataPagamento': ls.get('itemsFaturaEstaticos').dataPagamentoSelected,
    'totalMulta': ls.get('totalMulta'),
    'autor': ls.get('itemsFaturaEstaticos').autor,
    'number_item': 1,
    'tiDQ': 'Documento Processado por programa validado',
    'utilizador': 'Pedro'
  },
    estudante:
  {
    'number_recibo': '001',
    'number_deposito': '0109',
    'nome_empresa': 'INSTITUTO  SUPERIOR POLITÉCNICO PRIVADO DO LUENA',
    'cliente': 'Alexandrina Francisco de Almeida',
    'curso': 'ENSINO PRIMÁRIO',
    'turma': 'EP3ºM1B',
    'matricula': '3333332-26'

  },
    font: {
      titulo: (window.location.host.includes('192.168.20.2')) ? '10px' : '10px',
      corpotexto: (window.location.host.includes('192.168.20.2')) ? '9px' : '8px'
    },
    mes_ano: '',
    data_actual: '',
    dataHora: '',
    hora: '',
    formatter: 0,
    config: null,
    baseUrl: ''
  }),
  computed:{
    isBendizer (){
      return ls.get('i_id') === 7
    },
    isGab (){
      return ls.get('i_id') === 106
    },
    isNascer (){
      return ls.get('i_id') === 132
    },
    isCital() {
      return ls.get('i_id') === 10
    }
  },
  async created () {
     this.data_hora()
    this.config = ls.get('configuracaoinstituicao');
    this.getUrlImpressao()
  },

  methods: {

    async getUrlImpressao () {
      try {
        this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url) 
      } catch (error) {
      } finally {
        this.comporHtml()
      }
    },

    data_hora () {
      let data = new Date()
      this.mes_ano = (data.getFullYear()) + (data.getMonth() + 1)
      this.data_actual = data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear())
      this.hora = (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
      this.dataHora = data.getDate() + '-' + (data.getMonth() + 1) + '-' + (data.getFullYear()) + '  ' + (data.getHours()) + ':' + (data.getMinutes().toString().padStart(2, '0')) + ':' + (data.getSeconds())
    },
async comporHtml () {
        try {
          let templateFull = await axios.get('/obterRelatorioByDescricao/rp').then((res) => res.data[0]);
          let template = templateFull.documento;
          let produtoFactura = '';
          let resumoFactura = '';
          let i = 1;
          let totalMultas = 0;
          let totalpropina = 0;

          this.itemsDaFactura.forEach(element => {
            let interacao1 = templateFull.documentoiteracao1
            interacao1 = interacao1.replace('{{fkProduto}}', i++);
            interacao1 = interacao1.replace('{{mes}}', element.produto+'  '+utilitarios.getMonthDescriptionPropina(element.fkMes));
            interacao1 = interacao1.replace('{{qtdVenda}}', element.qtd_venda);
            interacao1 = interacao1.replace('{{precoUnitario}}', utilitarios.IntegerToMoneyValueFatura(element.precoUnitario));
            interacao1 = interacao1.replace('{{descontoLinha}}', element.descontoLinha) ;
            interacao1 = interacao1.replace('{{multa}}', utilitarios.IntegerToMoneyValueFatura(element.multa));
            interacao1 = interacao1.replace('{{cod.Ise}}', 'M21');
            interacao1 = interacao1.replace('{{subTotal}}', utilitarios.IntegerToMoneyValueFatura(element.subTotal));

            /**Dados pertencentes aos items do Recibo (Bendizer)  */
            interacao1 = interacao1.replace('{{idCurso}}', this.lastInscricaoNaTurma.idCurso);
            interacao1 = interacao1.replace('{{turma}}', this.lastInscricaoNaTurma.turma);
            interacao1 = interacao1.replace('{{dataVenda}}', utilitarios.ObterDataActural());
            interacao1 = interacao1.replace('{{parcela}}', this.ObterMonthName(element.fkMes));
            if(element.fkProduto === 1) totalpropina += element.subTotal
            /**Fim*/

            totalMultas += element.multa
            produtoFactura += interacao1;
          });
          if(!this.isBendizer){
            this.resumoImposto.forEach(element => {
            let interacao2 = templateFull.documentoiteracao2
            interacao2 = interacao2.replace('{{taxaTotal}}', '0,00');
            interacao2 = interacao2.replace('{{totalInsento}}', utilitarios.IntegerToMoneyValueFatura(element.totalIsento));
            interacao2 = interacao2.replace('{{totalIva}}', utilitarios.IntegerToMoneyValueFatura(element.totalIva));
            resumoFactura += interacao2
          });
          }

          
          let dados = {
            '{{logo}}' : this.config.logo,
            '{{instituicao}}' : this.config.nome,
            '{{site}}' : this.config.site,
            '{{email}}' : this.config.email,
            '{{tlf}}' : this.config.tlf,
            '{{contribuente}}' : this.config.contribuente,
            '{{capitalSocial}}' : this.config.capitalSocial,
            '{{numeroFactura}}' : this.factura.factura_recibo,
            '{{cliente}}' : this.factura.cliente,
            '{{matricula}}' : this.factura.matricula,
            '{{classe}}' : this.ObterClasse(parseInt(this.lastInscricaoNaTurma.idano_academico)),
            '{{turma}}' : this.lastInscricaoNaTurma.turma,
            '{{curso}}' : this.lastInscricaoNaTurma.curso,
            '{{dataActual}}': utilitarios.ObterDataActural(),
            '{{dataVenda}}' : this.dataVendaFactura,
            '{{anoLectivo}}' : ls.get('anolectivo'),
            '{{identificadorCOmprovativo}}' : this.infoFactura.identificadorComprovativo,
            '{{tpa}}' : this.infoFactura.tpaRef,
            '{{totalIliquido}}' : utilitarios.IntegerToMoneyValueFatura(this.infoFactura.valorIliquido),
            '{{totalDescontoComerciais}}' : '0,00',
            '{{totalDescontoFinanceiro}}' : '0,00',
            '{{saldoUsado}}' : utilitarios.IntegerToMoneyValueFatura(this.saldoUsado),
            '{{totalImposto}}' : '0,00',
            '{{saldoActual}}' : utilitarios.IntegerToMoneyValueFatura(this.saldo),
            '{{totalRecebido}}' : utilitarios.IntegerToMoneyValueFatura(this.infoFactura.valorAPagar),
            '{{totalDocumento}}' : utilitarios.IntegerToMoneyValueFatura(this.infoFactura.valorAPagar),
            '{{taxaTotal}}': '0,00',
            '{{autor}}' : this.infoFactura.autor,
            '{{dataVendaCompleta}}' : this.dataVendaFacturaFull,
            '{{totalRecebido}}' : utilitarios.IntegerToMoneyValueFatura(this.infoFactura.valorAPagar),
            '{{totalRecebidoDescricao}}' : utilitarios.ObterValorPorExtensao(this.infoFactura.valorAPagar),
            '{{horaACtual}}' : utilitarios.returnDataCorrectFormat(utilitarios.ObterDataActural()),
            '{{totalMultas}}': utilitarios.IntegerToMoneyValueFatura(totalMultas),
            '{{ItemsFactura}}' : produtoFactura,
            '{{resumoVendas}}' : resumoFactura,
            '{{totalpropina}}' : utilitarios.IntegerToMoneyValueFatura(totalpropina) /**Recibo do Bendizer  */
          }

          const expressaoRegular = new RegExp(Object.keys(dados).join("|"), "g");
          template = template.replace(expressaoRegular, (match) => dados[match]);

          let options = {
            'format': 'A4',
            'orientation': this.isBendizer ? 'portrait' : 'landscape',
            'border': { 'right': '5mm', 'left': '5mm' },
            'header': { 'height': '5mm' },
            'footer': { 'height': '5mm' }
          }
          if(this.isGab || this.isNascer || this.isCital){
            options = {
            "height": "297mm",   
            "width": "72.1mm",
            "orientation": "landscape",
            'border': { 'right': '2mm', 'left': '2mm' },
            'header': { 'height': '2mm' }
          }
          }
          impressaoService.htmlToPdf(template, options);
        } catch (error) {
           this.$store.state.loading_pdf = false;
        }
      },

      ObterClasse (idanoacademico){
         switch(idanoacademico){
           case 1:
             return '10ª Classe'
          case 2:
             return '11ª Classe'
          case 3:
             return '12ª Classe'
          case 4:
             return '13ª Classe'
            
          default:
            return 'Inválido'
             
         }
      },
      ObterMonthName (idmonth){
         switch(idmonth){
           case 1:
             return 'Janeiro'
          case 2:
             return 'Fevereiro'
          case 3:
             return 'Março'
          case 4:
             return 'Abril'
          case 5:
             return 'Maio'
          case 6:
             return 'Junho'
          case 7:
             return 'Julho'
          case 8:
             return 'Agosto'
          case 9:
             return 'Setembro'
          case 10:
             return 'Outubro'
          case 11:
             return 'Novembro'
          case 12:
             return 'Dezembro'            
          default:
            return 'N/A'
             
         }
      }
  }
}

</script>

  <style scoped>
  .v-progress-circular {
    margin: 1rem;
  }
  .progressCircularIsMatriculaURL {
    margin: 1rem;

    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -50px;
    margin-left: -100px;

  }
  </style>
